import type { EmployeeRow, PaymentMethod } from '../employeeTypes';

export type { PaymentMethod } from '../employeeTypes';

export type PaymentTabKey = 'bulletins' | 'acomptes' | 'soldes';

// ── Tab extraction from the normalized payment_methods sub-collection ──────────
// The three Identity tabs are derived by filtering on the per-method flags.

const methods = (e: EmployeeRow): PaymentMethod[] => e.payment_methods ?? [];

/** Payment methods active for payslips / bulletins. */
export function toBulletinMethods(e: EmployeeRow): PaymentMethod[] {
  return methods(e).filter(m => m.activePayslip);
}

/** Payment methods active for advances / acomptes. */
export function toAcompteMethods(e: EmployeeRow): PaymentMethod[] {
  return methods(e).filter(m => m.activeAdvance);
}

/** Payment methods active for settlements / soldes de tout compte. */
export function toSoldeMethods(e: EmployeeRow): PaymentMethod[] {
  return methods(e).filter(m => m.activeSettlement);
}
